(function () {
  'use strict';

  async function removeBundleItems(bundleId) {
    try {
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();

      const bundleItems = cart.items.filter(function (item) {
        return item.properties && item.properties['_bundle_id'] === bundleId;
      });

      if (bundleItems.length === 0) return;

      const updates = {};
      bundleItems.forEach(function (item) {
        updates[item.key] = 0;
      });

      const updateResponse = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates })
      });

      if (!updateResponse.ok) {
        console.error('Bundle removal failed:', updateResponse.status);
        throw new Error('cart_update_failed');
      }

      window.location.reload();
    } catch (err) {
      console.error('Bundle removal failed:', err);
      throw err;
    }
  }

  document.addEventListener('click', function (event) {
    const removeBtn = event.target.closest('[data-bundle-remove]');
    if (!removeBtn) return;

    event.preventDefault();
    event.stopPropagation();

    const bundleId = removeBtn.dataset.bundleRemove;
    if (!bundleId || removeBtn.disabled) return;

    removeBtn.disabled = true;
    removeBtn.setAttribute('aria-busy', 'true');
    const originalText = removeBtn.textContent;
    removeBtn.textContent = removeBtn.dataset.removingLabel || '…';

    removeBundleItems(bundleId)
      .catch(function () {
        removeBtn.disabled = false;
        removeBtn.removeAttribute('aria-busy');
        removeBtn.textContent = originalText;
      });
  });
})();
